import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { ButtonBar } from './UI';
import { ButtonMover } from './Buttons';
import { Sprite } from './Sprite';

const ExitPage = styled.div`
	padding-top: 0;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	padding-top: 0%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: 90vw;
	margin: 20vw auto 0;
`

export class ModalPlayerIntro extends Component {

	exit = () => {
		window.manager.playAudio("poopPop");
		store.modal = '';
	}

	render() {
		return (
			<ExitPage>
				<Content>
					<CloseBox>
						<Sprite width="100%" sprite={`tutorial_${this.props.human ? 17 : 16}.png`}/>
						<ButtonBar>
							<ButtonMover onClick={this.exit}>
								<Sprite localize sprite="btn_tutorial_ok.png" />
							</ButtonMover>
						</ButtonBar>
					</CloseBox>
				</Content>
			</ExitPage>
		);
	}
}
